// extracted by mini-css-extract-plugin
export default {"image":"Images_image__Uz0dy","noImage":"Images_noImage__rOYDo"};